import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@material-ui/core';

const ArchivedOnlyTableFilter = ({archivedOnly, onChange}) => {
  const handleIsActiveChange = (archivedOnly) => onChange({name: 'archivedOnly', value: archivedOnly});
  return (
    <div style={{width: 100}}>
      <Button
        size="small"
        variant="contained"
        color={!archivedOnly ? 'primary' : 'default'}
        onClick={() => handleIsActiveChange(false)}
        style={{
          maxWidth: 100,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        Active
      </Button>
      <Button
        size="small"
        variant="contained"
        color={archivedOnly ? 'primary' : 'default'}
        onClick={() => handleIsActiveChange(true)}
        style={{
          maxWidth: 100,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
      >
        Archived
      </Button>
    </div>
  );
};

ArchivedOnlyTableFilter.propTypes = {
  archivedOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

ArchivedOnlyTableFilter.defaultProps = {
  archivedOnly: false,
};

export default ArchivedOnlyTableFilter;
